import { ChartSkeleton } from '@/components/Chart';

const SOURCE_BAR_WIDTHS = [42, 58, 36, 64, 48, 55];

export function AlertRuleViewSkeleton() {
    return (
        <div className="h-full flex flex-col relative overflow-hidden pt-14">
            <div className="flex-1 flex overflow-y-auto scrollbar-hide px-4">
                <div className="flex-1 flex flex-col gap-6 pt-8 pb-24 min-w-0 max-w-content mx-auto">
                    <div className="flex flex-col gap-6">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 skeleton-item rounded" />
                            <div className="flex-1">
                                <div className="h-4 w-24 skeleton-item rounded mb-2" />
                                <div className="h-6 w-64 skeleton-item rounded" />
                            </div>
                        </div>
                        <div className="flex flex-col border-b border-grey-500 divide-y divide-grey-500 @wide:flex-row @wide:divide-y-0 @wide:divide-x">
                            {[0, 1].map((group) => (
                                <div
                                    key={group}
                                    className="flex flex-col @narrow:flex-row divide-y divide-grey-500 @narrow:divide-y-0 @narrow:divide-x flex-1 basis-0 min-w-0 @wide:w-1/2 @wide:flex-none"
                                >
                                    {[0, 1].map((index) => (
                                        <div
                                            key={`${group}-${index}`}
                                            className="px-4 py-4 flex flex-col justify-end gap-3 flex-1 basis-0"
                                        >
                                            <div className="h-4 w-16 skeleton-item rounded" />
                                            <div className="h-5 w-24 skeleton-item rounded" />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div>
                            <div className="flex items-center justify-between mb-8">
                                <div>
                                    <div className="h-4 w-16 skeleton-item rounded mb-2" />
                                    <div className="h-4 w-32 skeleton-item rounded" />
                                </div>
                                <div className="h-10 w-64 skeleton-item rounded-lg" />
                            </div>
                            <div className="mb-12">
                                <ChartSkeleton height={298} />
                            </div>
                            <div className="grid grid-cols-1 @medium:grid-cols-3 gap-x-8 gap-y-4">
                                {SOURCE_BAR_WIDTHS.map((width) => (
                                    <div
                                        key={width}
                                        className="flex flex-col gap-2"
                                    >
                                        <div className="h-3 w-20 skeleton-item rounded" />
                                        <div className="flex items-center gap-4">
                                            <div className="flex-1 h-2.5 bg-grey-800 rounded-sm overflow-hidden">
                                                <div
                                                    className="h-full skeleton-item rounded-sm"
                                                    style={{
                                                        width: `${width}%`,
                                                    }}
                                                />
                                            </div>
                                            <div className="h-3 w-4 skeleton-item rounded" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
